import { ClassicPreset } from 'rete';
import {
  SEND_MESSAGE_LABEL,
  MAP_RESULT_LABEL,
  CALL_API_LABEL,
  CALL_FUNCTION_LABEL,
  EVAL_NEXT_LABEL,
  STORE_DATA_LABEL,
  CONDITIONAL_STEP_LABEL,
  STORE_FILE_LABEL,
  COMMENT_LABEL,
} from 'app-constants/actionTypes';

const OUTPUT_CONFIG = {
  [SEND_MESSAGE_LABEL]: { dynamic: true, withLabels: true },
  [EVAL_NEXT_LABEL]: { dynamic: true, withLabels: false },
  [CONDITIONAL_STEP_LABEL]: { dynamic: true, withLabels: true },
  [CALL_API_LABEL]: { static: [['nxt', 'Next'], ['on_error', 'On error']] },
  [CALL_FUNCTION_LABEL]: { static: [['nxt', 'Next'], ['on_error', 'On error']] },
  [MAP_RESULT_LABEL]: { static: [['nxt', 'Next']] },
  [STORE_DATA_LABEL]: { static: [['nxt', 'Next']] },
  [STORE_FILE_LABEL]: { static: [['nxt', 'Next']] },
};

export const resolveOutputs = (label, data = {}) => {
  const cfg = OUTPUT_CONFIG[label];
  if (!cfg) return [];
  if (cfg.static) return cfg.static;
  if (data.outputs && data.outputs.length) {
    return data.outputs.map((key) => [
      key,
      cfg.withLabels ? (data.outputsLabels?.[key] ?? key) : key,
    ]);
  }
  return [['nxt', 'Next']];
};

// Crea un socket nuevo por nodo para poder asignarle color individualmente
// sin afectar a otros nodos (un socket compartido tendría el color del último render).
const makeSocket = () => new ClassicPreset.Socket('action');

// Devuelve el socket propio del nodo (el mismo para todos sus inputs/outputs).
export const getNodeSocket = (reteNode) => {
  const inp = Object.values(reteNode.inputs || {})[0];
  if (inp?.socket) return inp.socket;
  const out = Object.values(reteNode.outputs || {})[0];
  return out?.socket ?? makeSocket();
};

/** Nodo de Rete con los datos del bot (título, propiedades, salidas…) en `data`. */
/** @typedef {ClassicPreset.Node & { data: Record<string, any> }} BotNode */

/** @returns {BotNode} */
export const createNode = (label, data = {}) => {
  const node = /** @type {BotNode} */ (new ClassicPreset.Node(label));
  node.data = { ...data };

  if (label === COMMENT_LABEL) return node;

  // Socket propio de este nodo; el color se asigna en CustomNode antes del primer render.
  const socket = makeSocket();
  node.addInput('rcv', new ClassicPreset.Input(socket, 'Receive', true));
  resolveOutputs(label, data).forEach(([key, outLabel]) => {
    node.addOutput(key, new ClassicPreset.Output(socket, outLabel));
  });
  return node;
};
